import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=7b9cf59c&scoped=true&"
import script from "./MainDialog.vue?vue&type=script&lang=js&"
export * from "./MainDialog.vue?vue&type=script&lang=js&"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=7b9cf59c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9cf59c",
  null
  
)

export default component.exports